module.exports = __webpack_public_path__ + "img/slow-cooker-brown-sugar-pork-tenderloin.6a3bf656.jpg";